import { Component, Inject } from '@angular/core';

import { FeatureGuideService } from './feature-guide.service';
import { FeatureGuideTooltip, FeatureGuideTooltipToken } from './feature-guide-tooltip';

@Component({
  selector: 'pcs-feature-guide-tooltip',
  styleUrls: ['./feature-guide-tooltip.component.scss'],
  templateUrl: './feature-guide-tooltip.component.html'
})
export class FeatureGuideTooltipComponent {

  constructor(
    private readonly featureGuideService: FeatureGuideService,
    @Inject(FeatureGuideTooltipToken) public featureGuide: FeatureGuideTooltip
  ) {
  }

  hasNext() {
    return this.featureGuideService.hasNext();
  }

  hasPrevious() {
    return this.featureGuideService.hasPrevious();
  }

  next() {
    this.featureGuideService.next();
  }

  previous() {
    this.featureGuideService.previous();
  }

  complete() {
    this.featureGuideService.complete();
  }

  isActive(id) {
    return this.featureGuide.id === id;
  }

  getFeaturesIds(): string[] {
    return this.featureGuideService.getRegisteredFeatureGuidesIds();
  }

  trackByIndex(index) {
    return index;
  }

  multiRegisteredFeatures() {
    return this.featureGuideService.getRegisteredFeatureGuidesIds().length > 1;
  }
}
